import { Component, Inject } from '@angular/core';
import { CrewPermissionsService } from '../../core/crew-permissions.service';
import { ChildInfo } from '../../shared/nested-list.component';

@Component({
    selector: 'crew-requirements',
    template: require('./requirements.component.html')
})
export class Requirements {

    isPermissionWriteOrAdmin: boolean;

    constructor(
        @Inject("requirements") public requirements: Nema.Crew.Model.CompetenceRequirement[],
        @Inject("requirementSections") public requirementSections: Nema.Crew.Model.CompetenceRequirementCollection[],
        @Inject("authorities") public authorities: Nema.Crew.Model.Authority[],
        crewPermissionsService: CrewPermissionsService) {

        crewPermissionsService.isPermissionWriteOrAdmin().subscribe(value => this.isPermissionWriteOrAdmin = value);

        requirementSections.forEach(rs => (<any>rs).DisplayName = `${rs.Name} (${rs.Authority.Name})`);
    }

    public newEntityState = "app.settings.requirements.new";

    public authorityDetailsState = "app.settings.authorities.detail";

    public requirementSectionDetailsState = "app.settings.requirementsections.detail";

    public editEntityState = "app.settings.requirements.detail";

    public entityName = "Requirement";

    public entityNames = "Requirements";

    public getChildrenFuncs: ((item: any) => ChildInfo)[] =
        [(item: Nema.Crew.Model.Authority) => {
            return {
                headerLevel: 3,
                underlineHeader: true,
                children: item.CompetenceRequirementCollections,
                childDisplayName: 'Name',
                childDetailsState: this.requirementSectionDetailsState,
                getIsActive: (_item: Nema.Crew.Model.CompetenceRequirementCollection) => true
            }
        },
        (item: Nema.Crew.Model.CompetenceRequirementCollection) => {
            return {
                headerLevel: 4,
                children: item.CompetenceRequirements,
                childDisplayName: 'Name',
                childDetailsState: this.editEntityState,
                getIsActive: (_item: Nema.Crew.Model.CompetenceRequirement) => true
            }
        }];
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/requirements/requirements.component.ts